import { requestHandler, responseSuccessHandler } from '@bv/utils/http';
import axios from 'axios';

const URL = import.meta.env.VITE_API_BASE_URL;
const axiosDefaultConfig = {
  baseURL: URL + '/' + import.meta.env.VITE_API_VERSION,
  headers: {
    Accept: '*',
    'Content-type': 'application/json',
  },
};

const axiosInstance = axios.create(axiosDefaultConfig);

// Use the shared request handler from @bv
axiosInstance.interceptors.request.use(
  async (config: any) => {
    // Set fullResponse to true so the shared response handler returns the full object
    config.fullResponse = true;

    return requestHandler(config);
  },
  (error) => Promise.reject(error),
);

// Custom error handler that respects skipErrorToast option
const customErrorHandler = async (error: any) => {
  // Skip error handling if skipErrorToast is set
  if (error.config?.skipErrorToast) {
    return Promise.reject(error);
  }

  // Import the shared error handler for other errors
  const { responseErrorHandler } = await import('@bv/utils/http');
  return responseErrorHandler(error);
};

// Use the shared response handlers from @bv, with custom error handler
axiosInstance.interceptors.response.use(responseSuccessHandler, customErrorHandler);

export default axiosInstance;
